import React from 'react';
import { Text, Skeleton } from '@/components/ui';

interface NumberCellProps {
  value?: unknown;
  format?: string; // Format string for number formatting (e.g., 'currency', 'percent', or locale string)
  precision?: number; // Number of decimal places
  render?: () => React.ReactNode;
}

function NumberCell({ value, format, precision, render }: NumberCellProps) {
  if (render) {
    return <>{render()}</>;
  }

  if (value === null || value === undefined) {
    return (
      <Text size="2" color="gray" className="data-cell__number">
        —
      </Text>
    );
  }

  const formatNumber = (num: number): string => {
    if (typeof precision === 'number') {
      return num.toFixed(precision);
    }
    
    if (format) {
      // Handle special format strings
      if (format === 'currency') {
        return num.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
      }
      if (format === 'percent') {
        return `${(num * 100).toFixed(2)}%`;
      }
      // Use locale string with custom format
      return num.toLocaleString();
    }
    
    return num.toLocaleString();
  };

  const displayValue = typeof value === 'number' 
    ? formatNumber(value) 
    : String(value || '');

  return (
    <Text size="2" className="data-cell__number">
      {displayValue}
    </Text>
  );
}

export function NumberCellSkeleton() {
  return (
    <Skeleton style={{ width: '80px', height: '16px', borderRadius: '4px' }} />
  );
}

export default NumberCell;
